import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import CommonHeadingNBtns from "../../common-components/CommonHeadingNBtns";
import { showConfirmAlert } from "../../components-react/ReactAlert";
import { commonPostPutApi } from "../../../redux/reducers/commonApiSlice";
import { add_feedback, update_feedback } from "../../../data/ApiEndpoints";
import ReactQuillTextEditor from "../../components-react/inputs/ReactQuillTextEditor";

const validateForm = (formValues) => {
  let errors = {};

  //   const stripHtmlTags = (html) => {
  //     const div = document.createElement("div");
  //     div.innerHTML = html;
  //     return div.textContent || div.innerText || "";
  //   };

  //   const plainFeedback = stripHtmlTags(formValues.feedbackRemarks || "");

  if (!formValues.rating) {
    errors.feedbackRemarks =
      "Please provide a rating before submitting your feedback.";
  }

  if (
    formValues.rating &&
    formValues.rating < 4 &&
    !formValues.feedbackRemarks
  ) {
    errors.feedbackRemarks =
      "Your feedback is required for ratings below 4 to help us improve.";
  }
  //   else if (plainFeedback.length > 200) {
  //     errors.feedbackRemarks =
  //       `Feedback must not exceed 200 characters - ${plainFeedback.length || 0}. Please shorten your response.`;
  //   }

  return errors;
};

const FeatureFeedbackForm = ({
  userInfoData,
  rowData,
  isEdit,
  closeModal,
  callFunction,
  featureInfo,
}) => {
  const dispatch = useDispatch();
  const { postPutLoading } = useSelector((state) => state.common);

  const forminitials = {
    rating: isEdit && rowData?.rating ? rowData.rating : 0,
    feedbackRemarks: isEdit && rowData?.remarks ? rowData.remarks : "",
  };
  const [formValues, setFormValues] = useState(forminitials);
  const [formErrors, setFormErrors] = useState({});
  const [isSubmit, setIsSubmit] = useState(false);

  const onChangeTextInput = (content, fieldName) => {
    setIsSubmit(false);
    setFormValues((prev) => ({ ...prev, [fieldName]: content }));
  };

  const handleStarClick = (star) => {
    setFormValues((prev) => ({
      ...prev,
      rating: star,
    }));

    if (star >= 3) {
      setFormErrors((prev) => ({
        ...prev,
        feedbackRemarks: undefined,
      }));
    }
  };

  const onSubmit = () => {
    setFormErrors(validateForm(formValues));
    setIsSubmit(true);
  };

  const handleSubmitForm = async (payload) => {
    const method = isEdit ? "PUT" : "POST";
    const endpoint = isEdit ? update_feedback : add_feedback;
    const token = userInfoData?.token || "";

    try {
      const result = await dispatch(
        commonPostPutApi({ method, endpoint, payload, token })
      );

      if (result?.payload?.status) {
        setIsSubmit(false);
        setFormValues(forminitials);
        callFunction();
        closeModal();
        toast.success(result?.payload?.message || "Success!");
      } else {
        const errorMessage = result?.payload?.message || result?.error?.message;
        toast.error(errorMessage || "Something Went Wrong!");
      }
    } catch (error) {
      console.error("Error making POST request:", error);
    }
  };

  useEffect(() => {
    if (isSubmit && Object.keys(formErrors)?.length === 0) {
      const userData = {
        rating: formValues.rating || "",
        overview:
          formValues.rating === 1
            ? "Poor"
            : formValues.rating === 2
            ? "Not Bad"
            : formValues.rating === 3
            ? "Average"
            : formValues.rating === 4
            ? "Good"
            : formValues.rating === 5
            ? "Excellent"
            : "",
        remarks: formValues.feedbackRemarks || "",
        feature_guide_id: featureInfo?.uid || "",
        user_id: userInfoData?.uid || userInfoData?.user_id || "",
        gym_id: userInfoData?.gym_id || "",
      };

      if (isEdit) {
        userData.uid = rowData?.uid || "";
      }

      const handleConfirm = async () => {
        handleSubmitForm(userData);
        // console.log("userData=> ", userData);
      };

      showConfirmAlert(
        handleConfirm,
        `Are you sure!`,
        "Edit Form",
        "Submit Form"
      );
    }
  }, [isSubmit, formErrors]);

  return (
    <div className="createNewCTOModalContainer feature-docs mod-width-50p">
      <CommonHeadingNBtns
        title={`${featureInfo?.feature_name || ""} Feedback Form`}
        onClose={closeModal}
        onClick={onSubmit}
        isLoading={postPutLoading}
      />
      <form className="formContainer">
        <div className="formInputsGrid oneGridSystem">
          <div className="formInputBox ratingStart span4 mb30">
            <div className="ratingWrapper">
              {[1, 2, 3, 4, 5].map((star) => (
                <span
                  key={star}
                  className={`star ${
                    formValues.rating >= star ? "selected" : ""
                  }`}
                  onClick={() => handleStarClick(star)}
                >
                  ★
                </span>
              ))}
            </div>

            <div
              className="ratingLabel"
              style={{
                color:
                  formValues.rating === 1 ||
                  formValues.rating === 2 ||
                  formValues.rating === 3
                    ? "#c90808"
                    : formValues.rating === 4 || formValues.rating === 5
                    ? "#0a701b"
                    : "#555",
              }}
            >
              {formValues.rating === 1
                ? "Poor"
                : formValues.rating === 2
                ? "Not Bad"
                : formValues.rating === 3
                ? "Average"
                : formValues.rating === 4
                ? "Good"
                : formValues.rating === 5
                ? "Excellent"
                : "Click a star to rate"}
            </div>
          </div>

          <div className="formInputBox span4">
            <label htmlFor="feedbackRemarks" className="formInputLabel">
              {!formValues.rating
                ? "We value your feedback! Please let us know how we can improve."
                : formValues.rating < 3
                ? "We’re sorry your experience wasn’t ideal. Please share what didn’t meet your expectations and how we can improve."
                : "We’re glad you had a positive experience! Let us know what you liked and how we can make it even better."}{" "}
              {formValues.rating && formValues.rating < 3 ? (
                <span className="required">*</span>
              ) : null}
            </label>

            <div className="commonWrapper textAreaCommonWrapper with-auto-height no-border">
              <ReactQuillTextEditor
                value={formValues.feedbackRemarks}
                setValue={(content) =>
                  onChangeTextInput(content, "feedbackRemarks")
                }
                isError={formErrors?.feedbackRemarks ? "formError" : ""}
              />
              {/* <ReactQuill
                id="feedbackRemarks"
                name="feedbackRemarks"
                className={`formInput ${
                  formErrors?.feedbackRemarks ? "formError" : ""
                }`}
                placeholder="Enter Text, Links, Lists, Path..."
                value={formValues.feedbackRemarks}
                onChange={(content) =>
                  onChangeTextInput(content, "feedbackRemarks")
                }
              /> */}
            </div>

            <span className="error-label">
              {formErrors?.feedbackRemarks || ""}
            </span>
          </div>
        </div>
      </form>
    </div>
  );
};

export default FeatureFeedbackForm;
